import React, { useState } from "react";
import { Formik, Form } from "formik";
import { FormFirstStep } from "./firstStepForm";
import { StepButton } from "./stepButton";
import * as Yup from "yup";
import { ModalBody } from "reactstrap";
import { store } from "../../../redux/storeConfig/store";
import {
  createGate,
  endStaffSession,
  getStaff,
  startStaffSession,
} from "../../../redux/actions/api/apiAction";
import Title from "../../title";
import SpinnerComponent from "../../spinner/spinner";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import moment from "moment";

function MultiStepForGate({
  assignedStaffToConfirm,
  endCashOnSite,
  handleSubmit,
  id,
}) {
  const { currentStaffActiveSession, sessionIdToBeClosed } = useSelector(
    (state) => state.staffSession
  );
  const [isLoading, setIsLoading] = useState(false);

  handleSubmit = async (values) => {
    setIsLoading(true);
    await store.dispatch(
      endStaffSession({
        staffSessionId: sessionIdToBeClosed || id || currentStaffActiveSession.id,
        assignedStaffToConfirm: values.assignedStaffToConfirm,
        endCashOnSiteAmount: values.endCashOnSite,
      })
    );
    setIsLoading(false);
  };

  const formSchema = Yup.object().shape({
    assignedStaffToConfirm: Yup.number()
      .typeError("Assigned staff to confirm is required")
      .required("Assigned staff to confirm is required"),
    endCashOnSite: Yup.number()
      .typeError("Cash on site is required")
      .min(0, "Cash on site cannot be less than 0")
      .required("Cash on site is required"),
  });

  return (
    <>
      <ModalBody className="wod-first-step">
        <div className="modal-body-content">
          <div className="add-member-popup adding-popup bg-white card-panel">
            <div className="basic-info">
              <div className="info-title with-border">
                <Title
                  title="End Staff Session"
                  subtitlestyle="ctf-tx-secondary"
                  subtitle="Add info about the session"
                />
              </div>
              {isLoading ? (
                <div
                  style={{ height: "90%" }}
                  className="d-flex flex-column align-items-center justify-content-center"
                >
                  <SpinnerComponent />
                  <h3>Please wait</h3>
                </div>
              ) : (
                <Formik
                  enableReinitialize
                  initialValues={{
                    assignedStaffToConfirm,
                    endCashOnSite,
                  }}
                  onSubmit={handleSubmit}
                  validationSchema={formSchema}
                >
                  {({ errors, touched, values, setFieldValue }) => (
                    <Form className="d-flex flex-column justify-content-between h-100">
                      <FormFirstStep
                        errors={errors}
                        touched={touched}
                        values={values}
                        setFieldValue={setFieldValue}
                      />
                      <StepButton />
                    </Form>
                  )}
                </Formik>
              )}
            </div>
          </div>
        </div>
      </ModalBody>
    </>
  );
}

MultiStepForGate.defaultProps = {
  assignedStaffToConfirm: null,
  endCashOnSite: null,
  handleSubmit: () => {},
};

export default MultiStepForGate;
